import React, { useRef, useState, useMemo } from 'react';
import { auth, db } from '../firebase';
import {
  collection,
  query,
  orderBy,
  limit,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import ChatMessage from './ChatMessage';

// Note: react-firebase-hooks v5 removed the `idField` option from useCollectionData.
// Use useCollection instead to get snapshots, then manually extract doc.id.

function ChatRoom({ onMessageCountChange }) {
  const dummy = useRef();
  const messagesRef = useMemo(() => collection(db, 'messages'), []);
  const q = useMemo(() => query(messagesRef, orderBy('createdAt'), limit(25)), [messagesRef]);
  const [snapshot] = useCollection(q);
  const messages = useMemo(
    () => snapshot?.docs.map(doc => ({ id: doc.id, ...doc.data() })),
    [snapshot]
  );

  const [formValue, setFormValue] = useState('');

  // Notify parent of message count for header badge
  React.useEffect(() => {
    if (messages && onMessageCountChange) {
      onMessageCountChange(messages.length);
    }
  }, [messages, onMessageCountChange]);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!auth.currentUser) return;
    const { uid, photoURL, displayName } = auth.currentUser;

    await addDoc(messagesRef, {
      text: formValue,
      createdAt: serverTimestamp(),
      uid,
      photoURL,
      displayName: displayName || '',
    });

    setFormValue('');
    if (dummy.current) dummy.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <main className="chat-main">
        {messages &&
          messages.map((msg) => <ChatMessage key={msg.id} message={msg} />)}
        <span ref={dummy}></span>
      </main>

      <form className="chat-form" onSubmit={sendMessage}>
        <input
          className="chat-input"
          value={formValue}
          onChange={(e) => setFormValue(e.target.value)}
          placeholder="say something nice"
        />
        <button className="chat-send-btn" type="submit" disabled={!formValue}>
          Send
        </button>
      </form>
    </>
  );
}

export default ChatRoom;
